import React from "react";
import Banner from "../../components/UserSideComponents/Home/Banner";
import CategorySec from "../../components/UserSideComponents/Home/CategorySec";
import OfferSec from "../../components/UserSideComponents/Home/OfferSec";
import Seller from "../../components/UserSideComponents/Home/Seller";
import WatchAndBuy from "../../components/UserSideComponents/Home/WatchAndBuy";
import DesireChooseSection from "../../components/UserSideComponents/Home/DesireChooseSection";
import TrendingProducts from "../../components/UserSideComponents/Home/TrendingProducts";
import CompleteHomeSection from "../../components/UserSideComponents/Home/CompleteHomeSection";
import Offer from "../../components/UserSideComponents/Home/Offer";
import AllCategorySections from "../../components/UserSideComponents/Home/AllCategorySections";

const Home = () => (
  <div className="overflow-hidden">
    <Banner /> 
    <CategorySec />
    <OfferSec />
    <AllCategorySections />
    <Seller />
    {/* <WatchAndBuy /> */}
    <DesireChooseSection />
    <Offer />
    <TrendingProducts />
    <CompleteHomeSection />
  </div>
);

export default Home;
